import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
import { contactInfo } from '../mockData';

export const Footer = () => {
  return (
    <footer className="bg-black text-white border-t-2 border-[#00D4FF]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Logo Only */}
          <div className="space-y-4">
            <div className="flex items-center">
              <span className="text-xl font-bold">LiveryRUs</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#00D4FF]">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#00D4FF] transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-[#00D4FF] transition-colors text-sm">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/cities-rates" className="text-gray-400 hover:text-[#00D4FF] transition-colors text-sm">
                  Cities & Rates
                </Link>
              </li>
              <li>
                <Link to="/book" className="text-gray-400 hover:text-[#00D4FF] transition-colors text-sm">
                  Request Your Ride
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#00D4FF] transition-colors text-sm">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#00D4FF] transition-colors text-sm">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#00D4FF]">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3 text-gray-400 text-sm">
                <Phone size={18} className="mt-0.5 text-[#00D4FF] flex-shrink-0" />
                <a 
                  href={`tel:${contactInfo.phone}`}
                  className="text-gray-400 hover:text-[#00D4FF] transition-colors"
                >
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3 text-gray-400 text-sm">
                <Mail size={18} className="mt-0.5 text-[#00D4FF] flex-shrink-0" />
                <a 
                  href={`mailto:${contactInfo.email}`}
                  className="text-gray-400 hover:text-[#00D4FF] transition-colors"
                >
                  {contactInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-6 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} LiveryRUs. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 sm:mt-0">
            <Link to="/terms" className="text-gray-500 hover:text-[#00D4FF] text-sm transition-colors">
              Terms
            </Link>
            <Link to="/privacy" className="text-gray-500 hover:text-[#00D4FF] text-sm transition-colors">
              Privacy
            </Link>
            <Link to="/contact" className="text-gray-500 hover:text-[#00D4FF] text-sm transition-colors">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};